export default __webpack_public_path__ + "static/media/14.6990ea19.jpg";